(function() {
  // Header Menu Desktop
  var productMenuButton = document.querySelector('.Product-menu-head');
  var productMenu = document.querySelector('.product-menu>.list-menu');
  if(productMenuButton){
    productMenuButton.addEventListener('click', function() {
      productMenu.classList.toggle('open');
      productMenuButton.classList.toggle('open');
      document.querySelector('.product-menu>.list-menu');
      var productMenuClose = document.querySelectorAll('.Product-menu-wrap .header__menu-item');
      productMenuClose.forEach(function(items_lev) {
        items_lev?.classList.remove('open');
        items_lev?.nextElementSibling?.nextElementSibling?.classList.remove('open');
      });
    });
  }

  const forLevelSecond_hover = document.querySelectorAll(".product-menu>.Product-menu-wrap>li");
  forLevelSecond_hover.forEach(function(items) {
    items.addEventListener("mouseenter",(event) => {
      event.target.classList.add("open");
      event.target.querySelector('ul')?.classList.add("open");
    });
    items.addEventListener("mouseleave",(event) => {
      event.target.classList.remove("open");
      event.target.querySelector('ul')?.classList.remove("open");
    });
  });
  

  const forLevelThird_noclick = document.querySelectorAll(".forSubLevel_click>li");
  forLevelThird_noclick.forEach(function(items) {
    items.addEventListener("click",(event) => {
      event.target.classList.add("not-open");
      event.target.nextElementSibling?.nextElementSibling?.classList.add("not-open");
    });
  });

  const forLevelThird_click = document.querySelectorAll(".forSubLevel_click>li");
  forLevelThird_click.forEach(function(items) {
    items.addEventListener("mouseenter",(event) => {
      event.target.classList.add("hav-open");
      event.target.querySelector('ul')?.classList.add("hav-open");
    });
    items.addEventListener("mouseleave",(event) => {
      event.target.classList.remove("hav-open");
      event.target.querySelector('ul')?.classList.remove("hav-open");
    });
  });

  // header cart
  function validateTerms(agree, CartDrawerheckout) {
    if(agree.checked == false) {
      CartDrawerheckout.disabled = true;
    } else {
      CartDrawerheckout.disabled = false;
    } 
    localStorage.setItem("agree", agree.checked);
  }
  $('.header__icon--cart').on('click', function(){

    $.getJSON('/cart.json').then(cart => {
      fetch('/cart?view=item').then(response => response.text())
      .then(text => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          const cartCount = parseInt(sectionInnerHTML.querySelector(".cart-count").value)
          const cartFormInnerHTML = sectionInnerHTML.getElementById('CartDrawer').innerHTML;
          // const totalPrice = sectionInnerHTML.querySelector('#CartDrawer .totals__subtotal-value').innerHTML;
          $('#CartDrawer').html(cartFormInnerHTML)
          if(cartCount <= 0) {
            $('cart-drawer-items').addClass('is-empty');
            $('cart-drawer').addClass('is-empty')
          } else {
            $('cart-drawer').removeClass('is-empty')
            $('cart-drawer-items').removeClass('is-empty');
          }
          let CartDrawerheckout = document.querySelector("#CartDrawer-Checkout"), agree = document.querySelector("#agree");
        
          agree.checked = localStorage.getItem("agree") == "true";
          validateTerms(agree, CartDrawerheckout);
          agree.addEventListener("change", function() {
            validateTerms(agree, CartDrawerheckout)
          })

        if($('#cart-icon-bubble .cart-count-bubble').length===0){
          const cartNumber=document.createElement('div')
          cartNumber.className='cart-count-bubble'
          cartNumber.innerHTML=`
          <span aria-hidden="true">${cart.item_count}</span>
          <span class="visually-hidden">${cart.item_count} items</span>
          `
          $('#cart-icon-bubble').append(cartNumber)
        }else{
           $('.cart-count-bubble span[aria-hidden="true"]').each((_,count)=>$(count).text(cart.item_count))
        }
        $('#CartDrawer-Overlay').on('click',()=>{
          setTimeout(function(){
            document.querySelector(".drawer__close").click();
          },100)
          // $('cart-drawer').removeClass('active')
          // $('body').removeClass('overflow-hidden')
        })
      })
    });
    
      
  })

  // footer accordions

  var innerWidth = window.innerWidth;
  if (innerWidth < 750) {
    const accordions = document.querySelectorAll(".footer-block--menu");
    const openAccordion = (accordion) => {
      const content = accordion.querySelector(".footer-block--menu .footer-block__details-content");
      accordion.classList.toggle("accordion__active");
      content.style.maxHeight = content.scrollHeight + "px";
    };
    
    const closeAccordion = (accordion) => {
      const content = accordion.querySelector(".footer-block--menu .footer-block__details-content");
      accordion.classList.remove("accordion__active");
      content.style.maxHeight = null;
    };
    
    accordions.forEach((accordion) => {
      const intro = accordion.querySelector(".footer-block--menu .footer-block__heading");
      const content = accordion.querySelector(".footer-block--menu .footer-block__details-content");
    
      intro.onclick = () => {
        if (content.style.maxHeight) {
          closeAccordion(accordion);
        } else {
          accordions.forEach((accordion) => closeAccordion(accordion));
          openAccordion(accordion);
        }
      };
    });
  }
  
})();


window.setGridHeight = (selector) =>{
  this.heightArray = [];
  this.offsetArrayArray = [];
  this.sectionArray = [];


  document.querySelectorAll(selector).forEach((grid,i)=>{
    var tmp = {'index':i,'offsetheight':grid.closest(`[data-equal]`).offsetTop};
    this.offsetArrayArray.push(tmp)
  });

  this.diffrentsHeights = []
  this.offsetArrayArray.forEach(function(e){
    if(this.diffrentsHeights.includes(e.offsetheight) == false){
      this.diffrentsHeights.push(e.offsetheight)
    }
  })

  this.diffrentsHeights.forEach(function(e){
    var data = [];
    for(var i = 0; i < this.offsetArrayArray.length; i++){
      if(this.offsetArrayArray[i].offsetheight == e){
        data.push(this.offsetArrayArray[i]);
      }
    }

    var getAllHeightArray = [];
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].removeAttribute('style');
      getAllHeightArray.push(document.querySelectorAll(selector)[ele.index].offsetHeight);
    })

    var getMaxHeight = Math.max.apply(Math, getAllHeightArray);
    data.forEach(function(ele){
      document.querySelectorAll(selector)[ele.index].style.minHeight = getMaxHeight+'px';
    });
  })

}


$(document).ready(function () {

  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav',
    centerMode: true
  });
  $('.slider-nav').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    vertical: true,
    focusOnSelect: true,
    asNavFor: '.slider-for',
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false
        }
      },
      {
        breakpoint: 990,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping:false,
        }
      }
    ]
  });
  var numSlides = $('.slider-nav .slider-nav-item').length;
  if (screen.width > 989) {
    if ( numSlides == 1 || numSlides == 2 || numSlides == 3 || numSlides == 4) {
      $('.slider-nav').addClass('small-slides');
    }
  } else {
    if ( numSlides == 1 || numSlides == 2 || numSlides == 3) {
      $('.slider-nav').addClass('small-slides');
    }
  }

  $('.slider-for').slickLightbox({
    src: 'src',
    itemSelector: '.slider-for-item img',
    background: 'rgba(0, 0, 0, .7)'
  });

  
  $("predictive-search .spinner ").css({ display: 'block' });
  $('.brand_logo_wrap').not(".slick-initialized").slick({
    slidesToShow: 6,
    slidesToScroll: 2,
    arrows: false,
    loop: true,
    swipeToSlide: true,
    touchThreshold: 50,
    autoplay: true,
    autoplaySpeed: 4000,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4,
        }
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 2,
          slidesToScroll:2,
          cssEase: 'linear',
        }
      }
    ]
  });
  $(".brand_logo_main").css({ opacity: 1 });

  $('.featured_collection_slider_left .product-grid').slick({
    slidesToShow: 2,
    slidesToScroll: 2,
    swipeToSlide: true,
    touchThreshold: 50,
    arrows: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          appendArrows: $(`.featured_collection_slider_left .feature_collection-mob_arrow`),
          prevArrow: '<button type="button" class="slick-prev slick-arrow" name="previous" aria-label="previous"></button>',
          nextArrow: '<button type="button" class="slick-next slick-arrow" name="next" aria-label="next"></button>',
        }
      }
    ]
  });
  
  window.setGridHeight('.featured_collection_slider_left .card__content .card__heading');
  window.setGridHeight('.featured_collection_slider_left .card__content .price__container');
  window.setGridHeight('.new-featured-collection .quick-add');
  
  window.onresize = function() {
    window.setGridHeight('.featured_collection_slider_left .card__content .card__heading');
    window.setGridHeight('.featured_collection_slider_left .card__content .price__container');
    window.setGridHeight('.new-featured-collection .quick-add');
  }

  $('.blog_post_wrap .blog__posts').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    swipeToSlide: true,
    touchThreshold: 50,
    arrows: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          appendArrows: $('.blog-title-wrap .blog__posts-mob_arrow'),
          prevArrow: '<button type="button" class="slick-prev slick-arrow" name="previous" aria-label="previous"></button>',
          nextArrow: '<button type="button" class="slick-next slick-arrow" name="next" aria-label="next"></button>',
        }
      }
    ]
  });
  
  // window.setGridHeight('.blog__posts .card__heading');

  // contact page
  var checkBox_contact = document.querySelector(".contact__button input");
  var checkBoxSubscribe_contact = document.querySelector(".contact__button button.button");
  if ( checkBox_contact) {
    checkBox_contact.addEventListener("change",(event) => {
      var checkBox_check_contact = event.target.checked
      if (checkBox_check_contact == true){
        checkBoxSubscribe_contact.removeAttribute("disabled");
      } else {
        checkBoxSubscribe_contact.setAttribute("disabled", "");
      }
    });
  }

  // newsletter
  var checkBox = document.querySelector(".form_below_input input");
  var checkBoxSubscribe = document.querySelector(".newsletter-form__field-wrapper button#Subscribe");

  checkBox.addEventListener("change",(event) => {
    var checkBox_check = event.target.checked
    if (checkBox_check == true){
      checkBoxSubscribe.removeAttribute("disabled");
    } else {
      checkBoxSubscribe.setAttribute("disabled", "");
    }
  });

  // Register page
 
  $(".customer.register .forgot_link_wrap input").each(function () {
    $(this).on('change', function () {

       if( $(".register_page_wrap .field_wrap:nth-child(1) input").is(":checked") && $(".register_page_wrap .field_wrap:nth-child(2) input").is(":checked")){
         $("#create_customer button").removeClass('disabled'); 
         $("#create_customer button").removeAttr("disabled");
        } else {
         $("#create_customer button").addClass('disabled'); 
         $("#create_customer button").attr("disabled","disabled");    
        }
    })
  })

})

// Home Banner 
let sliderContainer = document.querySelectorAll('.slideshow__slide');

let pressed = false;
let startX;
let e_offsetX ;
let e_offsetx_x ;

sliderContainer.forEach(function (item,i) {
  item.addEventListener("mousedown", (e) => {
      pressed = true;
      e_offsetX = e.offsetX
  });
  item.addEventListener("mouseup", (e) => {
      // item.style.cursor = "grab";
      pressed = false;
      e_offsetx_x = e.offsetX
        
      if (e_offsetx_x > e_offsetX) {
        document.querySelector(".slider-counter__link--active").previousSibling?.click() 
      }
      if (e_offsetx_x < e_offsetX) {
        document.querySelector(".slider-counter__link--active").nextSibling?.click()
      }
  });
});

/* search category change */ 
// Get the select element and the hidden field
var selectElement = document.querySelector(".header_search-categories");
var hiddenField = document.querySelector(".header_search_collection");

if(selectElement){
  // Add an event listener to the select element
  selectElement.addEventListener("change", function() {
    // Get the selected value of the select element
    var selectedValue = selectElement.value;
    
    // Set the selected value into the hidden field
    hiddenField.value = selectedValue;
  });
}  

// Get the select element and the hidden field
var pageselectElement = document.querySelector(".search-page-categories");
var pagehiddenField = document.querySelector(".search_page_collection");

if(pageselectElement){
  // Add an event listener to the select element
  pageselectElement.addEventListener("change", function() {
    // Get the selected value of the select element
    var pageselectedValue = pageselectElement.value;
    
    // Set the selected value into the hidden field
    pagehiddenField.value = pageselectedValue;
  });
}


const collection_ac = document.querySelectorAll(".collection-list_sidebar_desktop ul li")
collection_ac.forEach(function(items) {
	var ca_svg = items.querySelector(".right_accordion_arrow");
	var ca_ul = items.querySelector("a~ul");
	
	if(ca_svg){
      ca_svg.addEventListener("click", function(item) {
        item.currentTarget.classList.toggle('open');
    	ca_ul.classList.toggle('open');
      });
    }
});


// Collection Page List View Grid View
window.grid_multiple_fun = function() {
    document.querySelector('.grid_multiple').classList.add('open');
    document.querySelector('.grid_single').classList.remove('open');
    document.querySelector('.collection_products_main').classList.add('grid_multiple-open');
    document.querySelector('.collection_products_main').classList.remove('grid_single-open');
}

window.grid_single_fun = function() {
    document.querySelector('.grid_single').classList.add('open');
    document.querySelector('.grid_multiple').classList.remove('open');
    document.querySelector('.collection_products_main').classList.add('grid_single-open');
    document.querySelector('.collection_products_main').classList.remove('grid_multiple-open');
}


window.checkGrids = function(){
  if ($('.grid_multiple').length > 0) {
    if (sessionStorage.getItem("grid-multiple") == 'true') {
      window.grid_multiple_fun();
    }
    $(document).on('click', '.grid_multiple', function() {
      window.grid_multiple_fun();
      sessionStorage.setItem("grid-multiple", true);
      sessionStorage.setItem("grid-single", null);
    });
  }
  
  if ($('.grid_single').length > 0) {
    if (sessionStorage.getItem("grid-single") == 'true') {
        window.grid_single_fun();
    }
    $(document).on('click', '.grid_single', function() {
      window.grid_single_fun();
      setTimeout(function() {
          $('.mobile_grid_multiple_img').slick('refresh');
      }, 100)
      sessionStorage.setItem("grid-single", true);
      sessionStorage.setItem("grid-multiple", null);
    })
  }
  var right_accordion_arrow = document.querySelector(".active-facets-vertical-filter");
  var filters_leftbar = document.querySelector("#FacetsWrapperDesktop");
  
  if(right_accordion_arrow){
    right_accordion_arrow.onclick = function () { 
      filters_leftbar.classList.toggle('open');
    };
  }


  // wishlist start
  document.dispatchEvent(new CustomEvent("swym:collections-loaded"));
  
  function swymCallbackFn(swat){
    // your API calls go here
 
    document.addEventListener("swym:collections-loaded", function(){
         
      swat.initializeActionButtons(".product-grid");
    })
  }
  if(!window.SwymCallbacks){
    window.SwymCallbacks = [];
  }
  window.SwymCallbacks.push(swymCallbackFn);
  // wishlist end
  
}


window.checkGrids();

// collection page filter



var list_sidebar_desktop_h3 = document.querySelector(".collection-list_sidebar_desktop h3");
var list_sidebar_desktop = document.querySelector(".collection-list_sidebar_desktop");

if(list_sidebar_desktop_h3){
  list_sidebar_desktop_h3.onclick = function () { 
    list_sidebar_desktop.classList.toggle('open');
  };
}

// menu open lavel one collection mobile

var c_m_second_l = document.querySelector(".collection-list_sidebar.collection-list_sidebar_mobile>h3");
var accordion_mobile_back_btn = document.querySelector(".accordion_mobile_back_btn");
var c_m_ff_second_ul = document.querySelector(".mobile-facets__main");
if(c_m_second_l){
  c_m_second_l.addEventListener("click", function(item) {
    c_m_ff_second_ul.classList.add('is-open');        
  });
}
if(accordion_mobile_back_btn){
  accordion_mobile_back_btn.addEventListener("click", function(item) {
    c_m_ff_second_ul.classList.remove('is-open');        
  });
}

// menu open lavel one collection mobile

$(".lv1_left_part_items>div.header__menu-item").each(function() {
  $(this).click(function () {
    $(".lv0_list_wraper").addClass("is-open")
    $(this).siblings(".HeaderMenu_secondL").addClass("is-open")
  })
})

$(".accordion_mobile_back_btn_lv1").click(function () {
  $(".lv0_list_wraper").removeClass("is-open")
  $(".HeaderMenu_secondL").removeClass("is-open") 
})

// menu open lave2 one collection mobile

$(".lv2_left_part_items>div.lv2_left_part").each(function() {
  $(this).click(function () {
    $(".mobile_second_l_collection").addClass("hav_is-open");
    $(this).siblings(".mobile_third_l_collection").addClass("is-open");
  })
})

$(".accordion_mobile_back_btn_lv2").click(function () {
  $(".mobile_second_l_collection").removeClass("hav_is-open");
  $(".mobile_third_l_collection").removeClass("is-open");
})







$( document ).ready(function() {
    $(".tab_content").hide();
    $(".product_tab_content").each(function () {
        $(this).find(".tab_content:first").show();
    });

    $("ul.tabs li").click(function () {
        var $container = $(this).closest(".product_tab_content");
        var activeTab = $(this).attr("rel");

        $container.find(".tab_content").hide();
        $container.find("#" + activeTab).fadeIn();

        $container.find("ul.tabs li").removeClass("active");
        $(this).addClass("active");

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $container.find(".tab_drawer_heading[rel='" + activeTab + "']").addClass("d_active");
    });

    $(".tab_drawer_heading").click(function () {
        var $container = $(this).closest(".product_tab_content");
        var d_activeTab = $(this).attr("rel");

        $container.find(".tab_content").hide();
        $container.find("#" + d_activeTab).fadeIn();

        $container.find(".tab_drawer_heading").removeClass("d_active");
        $(this).addClass("d_active");

        $container.find("ul.tabs li").removeClass("active");
        $container.find("ul.tabs li[rel='" + d_activeTab + "']").addClass("active");
    });

    // Product page zoom
    // $(".slider-for-item").on("mouseover", function() {
    //   $(this).find(".product-img--main__image").css({
    //       transform: "scale(" + $(this).attr("data-scale") + ")"
    //   });
    //   var e = $(this).find(".product-img--main__image").css({
    //       transform: "scale(" + $(this).attr("data-scale") + ")"
    //   });
    //   console.log(e, "chid")
    //   }).on("mouseout", function() {
    //       $(this).find(".product-img--main__image").css({
    //           transform: "scale(1)"
    //       })
    //   }).on("mousemove", function(e) {
    //       $(this).find(".product-img--main__image").css({
    //           "transform-origin": (e.pageX - $(this).offset().left) / $(this).width() * 100 + "% " + (e.pageY - $(this).offset().top) / $(this).height() * 100 + "%" 
    //       })
    //   }).each(function() {
    //       $(this).append('<div class="product-img--main__image"></div>').children(".product-img--main__image").css({
    //       "background-image": "url(" + $(this).find("img").attr("src") + ")"
    //   })
    // })

    // $(function() {
    //   $('.slider-for-item').each(function(){
    //     var originalImagePath = $(this).find('img').data('src');
    //     $(this).zoom({
    //       url: originalImagePath,
    //       magnify: 1
    //     });
    //   });
    // }); 

    

});


// login pages

function validation() {
  let form = document.getElementById('create_customer')
  let email = document.getElementById('RegisterForm-email').value
  let emailClass = document.getElementById('RegisterForm-email')
  let pattern = /^[^ ]+@[^ ]+\.[a-z]{2,3}$/

  if (email.match(pattern)) {
    emailClass.classList.add('valid')
    emailClass.classList.remove('invalid')
  } else {
    emailClass.classList.remove('valid')
    emailClass.classList.add('invalid')
  }

  if (email == '') {
    emailClass.classList.remove('valid')
    emailClass.classList.remove('invalid')
  }
}


// Faq Page

const accordions = document.querySelectorAll(".faq_item");
if (accordions) {
  const openAccordion = (accordion) => {
    const content = accordion.querySelector(".faq_content");
    accordion.classList.add("accordion__active");
    content.style.maxHeight = content.scrollHeight + "px";
  };
  
  const closeAccordion = (accordion) => {
    const content = accordion.querySelector(".faq_content");
    accordion.classList.remove("accordion__active");
    content.style.maxHeight = null;
  };
  
  accordions.forEach((accordion,index) => {
    const intro = accordion.querySelector("h3");
    const content = accordion.querySelector(".faq_content");
    intro.onclick = () => {
      if (content.style.maxHeight) {
        closeAccordion(accordion);
      } else {
        accordions.forEach((accordion) => closeAccordion(accordion));
        openAccordion(accordion);
      }
    };
    if(index == 0) intro.click();
  });
}

if (document.querySelector('#ContactForm')) {
  
let contactForm = document.querySelector('#ContactForm');

  contactForm.querySelector('button').addEventListener('click',function(ele){
    ele.preventDefault();
  
  let nameField = contactForm.querySelector('#ContactForm-name').value,
      emailField = contactForm.querySelector('#ContactForm-email').value,
      textAreaField = contactForm.querySelector('#ContactForm-body').value,
      nameError = contactForm.querySelector('#ContactForm-name').nextElementSibling.nextElementSibling,
      emailError = contactForm.querySelector('#ContactForm-email').nextElementSibling.nextElementSibling,
      bodyError = contactForm.querySelector('#ContactForm-body').nextElementSibling.nextElementSibling
  
      if (nameField.trim() === '') {
        nameError.classList.remove('hidden');
        contactForm.querySelector('#ContactForm-name').classList.add('error-input');
        return;
      }else{
        nameError.classList.add('hidden');
        contactForm.querySelector('#ContactForm-name').classList.remove('error-input');
      }
    
      if (emailField.trim() === '') {
        emailError.classList.remove('hidden');
        document.querySelector('.error-message-email').classList.add('hidden');
        contactForm.querySelector('#ContactForm-email').classList.add('error-input')
        return;
      }else{
        contactForm.querySelector('#ContactForm-email').classList.remove('error-input')
        emailError.classList.add('hidden');
      }
    
      var emailRegex = /^\S+@\S+\.\S+$/;
      if (!emailRegex.test(emailField)) {
        document.querySelector('.error-message-email').classList.remove('hidden');
        document.querySelector('#ContactForm-email').classList.add('error-input');
        return;
      }else{
        document.querySelector('.error-message-email').classList.add('hidden');
        document.querySelector('#ContactForm-email').classList.remove('error-input'); 
      }
    
      if (textAreaField.trim() === '') {
        bodyError.classList.remove('hidden');
        contactForm.querySelector('#ContactForm-body').classList.add('error-input')
        return;
      }else{
        bodyError.classList.add('hidden');
        contactForm.querySelector('#ContactForm-body').classList.remove('error-input')
      }
    
      contactForm.submit();
  
  })
}

// header cart icon 
    var preventRedirectionLinks = document.querySelectorAll('.prevent-redirection');
    preventRedirectionLinks.forEach(function(link) {
      link.addEventListener('click', function(event) {
        event.preventDefault();
      });
    });

document.getElementById('cart-icon-bubble-mobile').addEventListener('click', function () {
  document.getElementById('cart-icon-bubble').click();
});

// collection page mobile menu start

if(document.querySelectorAll('.collection-list_sidebar_desktop').length > 0){
  var sidebar = document.querySelector('.collection-list_sidebar_desktop');
  var sidebarClone = sidebar.cloneNode(true); // Clone the node, including its children
  
  document.getElementById("cloud_search_filters_root").onclick = function() {
    setTimeout(function() {
      var mobWrapper = document.querySelectorAll(".cloud-search-filters-pane");
      if (mobWrapper.length > 0) {
        var filterElm = document.querySelector('.cloud-search-filters-pane__heading');
        var div = document.createElement('div');
        div.appendChild(sidebarClone); // Append the cloned node to the new container
        document.querySelector(".cloud-search-filters-pane").insertBefore(div, filterElm);
  
  
        var list_sidebar_desktop_h3 = document.querySelector(".cloud-search-filters-pane .collection-list_sidebar_desktop h3");
        var list_sidebar_desktop = document.querySelector(".cloud-search-filters-pane .collection-list_sidebar_desktop");
        
        if(list_sidebar_desktop_h3){
          list_sidebar_desktop_h3.onclick = function () { 
            list_sidebar_desktop.classList.toggle('open');
          };
        }
  
      var collection_ac1= document.querySelectorAll(".cloud-search-filters-pane .collection-list_sidebar_desktop ul li")
      collection_ac1.forEach(function(items) {
          var ca_svg = items.querySelector(".right_accordion_arrow");
          var ca_ul = items.querySelector("a~ul");
          if(ca_svg){
             if(!ca_svg.classList.contains("eventadded")){
              ca_svg.classList.add("eventadded");
              ca_svg.addEventListener("click", function(item) {
                item.currentTarget.classList.toggle('open');
                ca_ul.classList.toggle('open');
              });
            }
          }
      });
        
      }
    }, 100);
  };
}


// collection page mobile menu end

// collection cloud filter start
const checkFilter = setInterval(() => {
  if (document.querySelectorAll('.cloud-search-filters-sidebar__heading').length > 0) {
     $('.cloud-search-filters-sidebar__heading').parent().addClass('open');
    $('.cloud-search-filters-sidebar__heading').on('click', function () {
      $(this).parent().toggleClass('open');
    });
    $('.cloud-search-filters-sidebar__heading').each(function () {
    $(this).append(`<span>ZWIŃ <svg width="14" height="2" viewBox="0 0 14 2" fill="none" class="minus" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H0V0H14V2Z" fill="#2F2C3F"></path></svg>
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" class="plus" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.8333 6.83329H6.83329V11.8333H5.16663V6.83329H0.166626V5.16663H5.16663V0.166626H6.83329V5.16663H11.8333V6.83329Z" fill="#494E58"></path>
    </svg>
    </span>`);
      });
    clearInterval(checkFilter);
  }
}, 100);



const mobileFilter = setInterval(() => {
  if (document.querySelectorAll('.cloud-search-filters-pane__heading').length > 0) {
    if(!document.querySelector('.cloud-search-filters-pane__heading').classList.contains("eventadded")){
      document.querySelector('.cloud-search-filters-pane__heading').classList.add("eventadded");
       $('.cloud-search-filters-pane__heading').parent().addClass('open');
      $('.cloud-search-filters-pane__heading').on('click', function (e) {
        $(this).parent().toggleClass('open');
      });
      $('.cloud-search-filters-pane__heading').each(function () {
      $(this).append(`<span>ZWIŃ <svg width="14" height="2" viewBox="0 0 14 2" fill="none" class="minus" xmlns="http://www.w3.org/2000/svg"><path d="M14 2H0V0H14V2Z" fill="#2F2C3F"></path></svg>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" class="plus" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.8333 6.83329H6.83329V11.8333H5.16663V6.83329H0.166626V5.16663H5.16663V0.166626H6.83329V5.16663H11.8333V6.83329Z" fill="#494E58"></path>
      </svg>
      </span>`);
        });
      // clearInterval(mobileFilter);
    }
  }
}, 100);


// collection cloud filter end


window.addEventListener('resize', function(){

  var collection_ac1= document.querySelectorAll(".cloud-search-filters-pane .collection-list_sidebar_desktop ul li")
    collection_ac1.forEach(function(items) {
        var ca_svg = items.querySelector(".right_accordion_arrow");
        var ca_ul = items.querySelector("a~ul");
        if(ca_svg){
           if(!ca_svg.classList.contains("eventadded")){
            ca_svg.classList.add("eventadded");
            ca_svg.addEventListener("click", function(item) {
              item.currentTarget.classList.toggle('open');
              ca_ul.classList.toggle('open');
            });
          }
        }
    });
  
});

document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelectorAll('.ProductCount#GridCollection').length > 0){
    // Get the product count per page <select> element
    const productsPerPageSelect = document.querySelector('.ProductCount#GridCollection');
    productsPerPageSelect.addEventListener('change', function (e) {
      e.preventDefault();
      const selectedValue = this.value;
      updateCartAttribute(selectedValue);
    });
    
    // Function to update the cart attribute with the selected products per page value
    function updateCartAttribute(value) {
      const formData = new FormData();
      formData.append('attributes[pagination]', value);
      fetch('/cart/update.js', {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        window.location.reload();
        // console.log(data);
      })
      .catch(error => {
        console.error('Error updating cart attribute:', error);
      });
    }
  }
});

// document.addEventListener("DOMContentLoaded", (e) => {
//   document.querySelector("#GridCollection").addEventListener("change", function(e) {
//     e.preventDefault();
//     if (window.location.href.includes("?")) {
//       var urlSearchParams = window.location.href.split("?")[1].split("&");
//       var viewFound = false;
//       for (param in urlSearchParams) {
//         if (urlSearchParams[param].includes("view=grid")) {
//           console.log("view found !!");
//           urlSearchParams[param] = "view=" + e.currentTarget.value;
//           viewFound = true;
//         }
//       }
//       if (viewFound) {

//       console.log(urlSearchParams);
      
//       console.log(urlSearchParams.join('&'));

//       window.location.href = window.location.href.split("?")[0] + "?" + urlSearchParams.join('&');

        
              
              
        
        
//       } else {
        
//       }
//     } else {
//       window.location.href = window.location.href + "?view=" + e.currentTarget.value;
//     }
//   });
// });


// PDP page you tube video section 
document.addEventListener("DOMContentLoaded", function () {
  // Check if the YouTube IFrame API is ready
  if (typeof YT !== 'undefined' && YT.loaded) {
    initializePlayers();
  } else {
    // If not ready, wait for the API to be ready
    window.onYouTubeIframeAPIReady = initializePlayers;
    var tag = document.createElement('script');
    tag.id = 'iframe-demo';
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }

  // Function to initialize YouTube players
  function initializePlayers() {
    var tag = document.createElement('script');
    tag.id = 'iframe-demo';
    tag.src = 'https://www.youtube.com/iframe_api';
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    window.players = [];
    document.querySelectorAll(".all-iframes").forEach((el, i) => {
      var player;
      function onYouTubeIframeAPIReady(elId) {
        player = new YT.Player(elId, {
          events: {
            'onReady': onPlayerReady
          }
        });
      }
      function onPlayerReady(event) {
        window.players[event.target.g.dataset.video_index] = event.target;
      }
      onYouTubeIframeAPIReady(el.id);
    })
    
    $('.slider-nav').on('afterChange', function(slick, currentSlide){
      if(document.querySelector(".grid__item .product__images--slider .slider-for .slick-current.slick-active iframe")){
        var vidDataIndex =  document.querySelector(".grid__item .product__images--slider .slider-for .slick-current.slick-active iframe").dataset.video_index;
        for(let vid_i in window.players){
          if(window.players[vid_i]){
            window.players[vid_i].pauseVideo();
          }
        }        
        window.players[vidDataIndex].playVideo();
      }
      else{
        for(let vid_i in window.players){
          if(window.players[vid_i]){
            window.players[vid_i].pauseVideo();
          }
        }   
      }
    });
  }
});


// back to top button
  document.addEventListener("DOMContentLoaded", function() {
    if(document.getElementById("back-to-top-button")){
      var backToTopButton = document.getElementById("back-to-top-button");
      window.addEventListener("scroll", function() {
        if (window.scrollY > 200) {
          backToTopButton.style.display = "block";
        } else {
          backToTopButton.style.display = "none";
        }
      });
    
      backToTopButton.addEventListener("click", function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
      });
    }
});

// MILWAUKEE long description
  document.querySelectorAll('.toggle-button-show-description').forEach(button => {
        button.addEventListener('click', function() {
            const content = this.parentElement.nextElementSibling;
            // Toggle 'open' class to control visibility
            if (content.classList.contains('open')) {
                content.classList.remove('open');
                this.textContent = 'Rozwiń opis';
            } else {
                content.classList.add('open');
                this.textContent = 'Zwiń opis';
            }
        });
    });

// load products wih 4-4 items on metafield based related products
 var work = $(".product-grid-related-products-meta");
  if (work.length) {
    var items = work.find(".grid__item");
    var loadMore = $(".see_more_rec");
    var maxItems = 4;
    var loadItems = 4;
    var hiddenClass = "hiddenStyleCustom";

    items.each(function(index, item) {
      if (index >= maxItems) {
        $(item).addClass(hiddenClass);
        loadMore.addClass("have-more-product");
      }
    });

    loadMore.on("click", function() {
      work.find("." + hiddenClass).slice(0, loadItems).removeClass(hiddenClass);

      if (work.find("." + hiddenClass).length === 0) {
        loadMore.hide(); // Hide the "See More" button
      }
    });
    if (work.find(".grid__item").length <= 4 ){
      loadMore.hide(); // Hide the "See More" button
    }
  }


// SEARCH PRELOADER JS START

window.addEventListener("load", function () {
    const loader = document.querySelector(".onload__loader_hidden");
    if (loader) {
        loader.style.display = "block"; // Change to "flex", "grid", etc., if needed
    }
});

// SEARCH PRELOADER JS END

// Create a MutationObserver to watch for the element
const observer = new MutationObserver((mutationsList, observer) => {
  for (const mutation of mutationsList) {
    if (mutation.type === 'childList') {
      const targetElement = document.querySelector("button.deferred-media__poster .shopify-model-viewer-ui");
      if (targetElement) {
        const parentElement = targetElement.parentElement;
        if (parentElement) {
          parentElement.parentElement.insertBefore(targetElement, parentElement.nextSibling);

          // observer.disconnect();
          console.log('Element found and moved.');
        }
      }
    }
  }
});

// Start observing the DOM for changes
observer.observe(document.body, {
  childList: true, // Watch for added/deleted child nodes
  subtree: true,   // Watch the entire DOM tree
});

console.log('Observer is running...');


// Expose globally
window.initCartCheckbox = function() {
  const checkbox = document.getElementById('agree');
  const checkoutButton = document.getElementById('CartDrawer-Checkout');
  const errorMsg = document.querySelector('.cart-terms_error');

  if (!checkbox || !checkoutButton || !errorMsg) return false;

  checkoutButton.disabled = !checkbox.checked;

  if (!checkbox.dataset.listener) {
    checkbox.addEventListener('change', function() {
      checkoutButton.disabled = !checkbox.checked;
      if (checkbox.checked) errorMsg.classList.add('hide');
    });
    checkbox.dataset.listener = 'true';
  }

  if (!checkoutButton.dataset.listener) {
    checkoutButton.addEventListener('click', function(e) {
      if (!checkbox.checked) {
        e.preventDefault();
        errorMsg.classList.remove('hide');
      }
    });
    checkoutButton.dataset.listener = 'true';
  }

  return true;
};

window.initCartCheckbox();
// if(document.body.classList.contains("template--product") || document.body.classList.contains("template--index")) {
//   const etrustedObserver = new MutationObserver((mutations, obs) => {
//     const widget = document.querySelector('etrusted-widget');
    
//     if (widget) {
//       widget.setAttribute('data-theme', 'light');
//       console.log('Target acquired: data-theme set to light.');
//       // Stop watching once the job is done to save resources
//       obs.disconnect();
//     }
//   });
//   // Start observing the document body for added nodes
//   etrustedObserver.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// }